import { RootState, SettingsState as State } from '../models/state';

import { createAction, handleActions } from 'redux-actions';

import { LANGUAGES } from '../utils/constants';

// Actions
export const SET_LANGUAGE = 'settings/SET_LANGUAGE';
export const SET_DEVICE = 'settings/SET_DEVICE';

// Action creators
export const setLanguage = createAction(SET_LANGUAGE);
export const setDevice = createAction(SET_DEVICE);

// Default state
const defaultState: State = {
  language: LANGUAGES.find((l) => l.locale === 'en-ca')!.id,
  locale: LANGUAGES.find((l) => l.locale === 'en-ca')!.locale,
  isMobile: true
};

// Reducer
const reducer = handleActions(
  {
    [SET_LANGUAGE]: (state, { payload }: any) => ({
      ...state,
      language: payload.id,
      locale: payload.locale
    }),
    [SET_DEVICE]: (state, { payload }: any) => ({
      ...state,
      isMobile: payload
    })
  },
  defaultState
);

export const selectLanguageSettings = (state: RootState) =>
  state.settings.language;

export const selectLocalSettings = (state: RootState) => state.settings.locale;

export const selectIsMobile = (state: RootState) => state.settings.isMobile;

export default reducer;
